import React from 'react'
import ReactScrollLink from '../General/ReactScollLink'
import PosterGrid from '../PosterGrid'
import SliderBasicLinkButton from '../SliderBasic/SliderBasicLinkButton'

const ShowtimesHead = ({title, items, moviesData, isMobile, showtimesOpen, scrollToPosition, onToggleShowtimes}) => (
    <div className="showtimes-head">
        <div className="showtimes-head-content">
            <h2 className="showtimes-head-title headline title-xlarge-black">{title}</h2>

            <ReactScrollLink 
                className="showtimes-head-button"
                to={showtimesOpen ? false : scrollToPosition}
                smooth={true} 
                offset={-100}
                onClick={() => onToggleShowtimes({id: '', movieTitle: title})}
            >
                <SliderBasicLinkButton 
                    linkText={'showtimes'} 
                    ticketButtonClass='' 
                />
            </ReactScrollLink>
        </div>

        <PosterGrid 
            movies={moviesData}
            isMobile={isMobile}
            moviesOrder={items}
        />
    </div>
)

export default ShowtimesHead